import { useEffect, useState } from "react";
import { Moon, Sun, Monitor } from "lucide-react";

const KEY = "tcw-theme";
const resolve = (choice) =>
  choice === "system"
    ? (window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark")
    : choice;

export function applyTheme(choice) {
  document.documentElement.setAttribute("data-theme", resolve(choice));
}

const OPTIONS = [
  { id: "dark", icon: Moon, label: "DARK" },
  { id: "light", icon: Sun, label: "DAY" },
  { id: "system", icon: Monitor, label: "SYSTEM" },
];

export function ThemeToggle() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY) || "system");

  useEffect(() => {
    applyTheme(choice);
    localStorage.setItem(KEY, choice);
    if (choice === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: light)");
      const on = () => applyTheme("system");
      mq.addEventListener("change", on);
      return () => mq.removeEventListener("change", on);
    }
  }, [choice]);

  return (
    <div data-testid="theme-toggle" className="inline-flex items-center border hairline">
      {OPTIONS.map((o) => {
        const Icon = o.icon;
        const active = choice === o.id;
        return (
          <button key={o.id} onClick={() => setChoice(o.id)} title={o.label} aria-label={o.label}
            data-testid={`theme-${o.id}`}
            className={`p-2 transition-colors ${active ? "bg-[#EF3340] text-white" : "text-stone-500 hover:text-[#EF3340]"}`}>
            <Icon className="w-3.5 h-3.5" />
          </button>
        );
      })}
    </div>
  );
}
